<template>
  <!-- import competitor prices modal -->
  <div class="table-crud-modal price__modal" ref="modal">
    <h2 class="lvl2-heading">Importer des labos de marques</h2>
    <el-form
      label-position="left"
      :model="params"
      :status-icon="true"
      ref="importLabosForm"
    >
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item prop="labos">
            <span>Fichier:</span>
            <FileUpload
              name="price-upload"
              placeholder="Importer labos..."
              :error="labosFile"
              :acceptedTypes="[
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                'text/csv'
              ]"
              @file-upload="params.labos = $event"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item style="text-align: right">
        <base-button @click.prevent.stop.native="handleSubmit" :fluid="false"
          >Ajouter</base-button
        >
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { Message, Form, FormItem, Row, Col } from "element-ui"
import { mapGetters } from "vuex"
import FileUpload from "@/components/FileUpload.vue"
import { importLabos } from "@/api/labos"
import { loaderMixin } from "@/mixins"
import { emitter } from "@/utils"

export default {
  components: {
    FileUpload,
    ElForm: Form,
    ElFormItem: FormItem,
    ElRow: Row,
    ElCol: Col
  },
  computed: {
    ...mapGetters(["modal"])
  },
  data() {
    return {
      params: {
        labos: null
      },
      labosFile: false
    }
  },
  mixins: [loaderMixin],
  methods: {
    handleSubmit() {
      const { ...params } = this.params

      if (!params.labos) {
        this.labosFile = true
        Message.error("Veuillez télécharger un fichier")
        return
      }

      const formData = new FormData()
      formData.append("labos", params.labos)
      //console.log(formData)
      importLabos(params, formData)
        .then(() => {
          Message.success("Labos de marques ajouté(s)")
          emitter.$emit("update-table")
          this.closeLoader()
          this.$store.dispatch("closeModal")
        })
        .catch(({ err }) => {
          console.log(err)
          this.closeLoader()
        })
    }
  }
}
</script>

<style lang="scss">
.price {
  &__modal {
    .el-form-item {
      margin: 0 !important;
    }
    .el-row {
      display: flex;
      align-items: center;
      margin: 20px 0;
    }
  }
  &__button {
    &-action {
      // background-color: #000;
      cursor: pointer;
      width: 40px;
      height: 40px;
      display: flex;
      justify-content: center;
      align-items: center;
      border: 2px solid #fbac2e;
      border: 2px solid var(--color-secondary, #fbac2e);
      outline: none;
      color: white;
      -webkit-transition: all 0.2s ease;
      transition: all 0.2s ease;
      font-size: 25px;
      text-transform: uppercase;
      background: var(--color-secondary, #fbac2e);
      &:hover {
        box-shadow: 0 20px 40px 0 rgba(0, 0, 0, 0.16);
      }
      &.marged {
        margin: 0 14px 20px auto;
      }
    }
  }
}
</style>
